
  import { computed, defineComponent } from 'vue';
  import { Button, Icon, Illustration, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import { $infoComponentStatus, changeInfoStatus } from '@/store/components/index';
  import { useStore } from 'effector-vue/composition';
  import { $lastTransferredCallNumbers, activeCalls } from '@/store/calls/index';

  export default defineComponent({
    name: 'Info',
    components: { Typography, Illustration, Button, Icon },
    setup() {
      const { t } = useI18n();
      const infoStatus = useStore($infoComponentStatus);
      const lastTransferredCallNumbers = useStore($lastTransferredCallNumbers);
      const getTitleClass = computed(() => ({
        'title-welcome': infoStatus.value === 'isNotSignIn',
        'title-text': infoStatus.value !== 'isNotSignIn',
      }));
      const getDescriptionClass = computed(() => ({
        'description-welcome': infoStatus.value === 'isNotSignIn',
        'Description-text': infoStatus.value !== 'isNotSignIn',
      }));

      return {
        t,
        infoStatus,
        changeInfoStatus,
        activeCalls,
        lastTransferredCallNumbers,
        getTitleClass,
        getDescriptionClass,
      };
    },
  });
